import { FormEvent, useState } from 'react'
import { IMaskInput } from 'react-imask'
import Button from '../Button'
import * as S from './styles'

const Mensagem = () => {
  const [cpf, setCpf] = useState('')
  const [telefone, setTelefone] = useState('')
  const [mensagem, setMensagem] = useState('')

  const enviarMensagem = (e: FormEvent) => {
    if (cpf === '' || telefone === '' || mensagem === '') {
      e.preventDefault()
      alert('Preencha todos os campos!')
    } else {
      alert('Mensagem enviada!')
    }
  }

  return (
    <S.Mensagem onSubmit={enviarMensagem}>
      <IMaskInput
        mask="000.000.000-00"
        type="tel"
        placeholder="Digite seu CPF"
        onBlur={(e) => setCpf(e.target.value)}
      />
      <IMaskInput
        mask="(00) 00000-0000"
        type="tel"
        placeholder="Digite seu Telefone"
        onBlur={(e) => setTelefone(e.target.value)}
      />
      <textarea
        rows={5}
        placeholder="Digite o assunto"
        onChange={(e) => setMensagem(e.target.value)}
      ></textarea>
      <Button>Enviar mensagem</Button>
    </S.Mensagem>
  )
}

export default Mensagem
